// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2_2la","obliqueLineWrap":"membershipbadge_obliqueLineWrap__23HwU","obliqueLine":"membershipbadge_obliqueLine__19h1_"};